import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 16,
    // paddingVertical: 5,
  },
  sectionTitle: {
    fontWeight: '700',
    marginBottom: 12,
    color: '#1C1C1E',
  },
  fieldWrapper: {
    marginBottom: 16,
  },
  fieldLabel: {
    fontSize: 16,
    color: '#1E1E1E',
    marginBottom: 6,
    fontWeight: '500',
    marginTop: 5,
    paddingHorizontal: 6,
    paddingTop: 6,
    paddingBottom: 4,
  },
  input: {
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 0,
    minHeight: 48,
    fontSize: 14,
    color: '#1C1C1E',
    backgroundColor: '#FFF',
    textAlignVertical: 'center',
    includeFontPadding: false,
  },
  streetInput: {
    paddingBottom: 0,
  },
  inputError: {
    borderColor: '#900B09',
  },
  errorText: {
    fontSize: 14,
    color: '#900B09',
    fontWeight: '400',
    marginTop: 4,
  },

  disabledInput: {
    minHeight: 44,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 0,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
  },
  disabledText: {
    fontSize: 14,
    color: '#1C1C1E',
    flex: 1,
    includeFontPadding: false,
    textAlignVertical: 'center',
  },
});
